document.querySelectorAll('.adam__share__link__url__copy').forEach((el) => {
    el.addEventListener('click', function () {
        const copyText = el.closest('.adam__share__link__url').querySelector('.adam__share__link__url__input');
        copyText.select();
        copyText.setSelectionRange(0, 99999);
        if (navigator.clipboard) { // funziona solo con HTTPS
            navigator.clipboard.writeText(copyText.value);
        }
    });
});